export const filtersToUploads = {
  masterData: {
    limitOptions: 5,
    useBusinessUnit: true,
    useLabeledFamilies: true,
    useSuppliers: true,
    useMaterialGroup: true,
    useActiveMaterial: true,
    useCountry: false,
  },
  planningBottles: {
    isBottles: true,
    useBusinessUnit: true,
    useDateRange: true,
    useLabeledFamilies: true,
    useSuppliers: true,
  },
};